(function(){
  if (!document.querySelector('.ffs')) return;
  var FREE = 3000; // pence
  var money = function(p){ return '£' + (p / 100).toFixed(2); };
  var b = document.body;

  // Pack size buttons (or dropdown) on each drink: update price, price per can, button and picture
  document.addEventListener('change', function(e){
    if (!e.target.closest) return;
    var sel = e.target.closest('.ffs-size__select');
    var o = sel ? sel.selectedOptions[0] : e.target.closest('.ffs-seg__opt input');
    if (!o) return;
    var card = e.target.closest('[data-card]');
    if (!card) return;
    var p = card.querySelector('.ffs-card__price [data-price]'); if (p) p.textContent = o.dataset.price;
    var u = card.querySelector('.ffs-card__price [data-unit]'); if (u) u.textContent = o.dataset.unit;
    var btn = card.querySelector('[data-add]');
    if (btn) { btn.disabled = o.dataset.available !== 'true'; btn.textContent = btn.disabled ? 'Sold out' : 'Add to basket'; }
    [].forEach.call(card.querySelectorAll('[data-link]'), function(a){ var url = new URL(a.href); url.searchParams.set('variant', o.value); a.href = url.href; });
    var img = card.querySelector('img'); if (img && o.dataset.image) { img.removeAttribute('srcset'); img.src = o.dataset.image; }
  });

  // Basket bar (phones): appears once something is in the basket, with the free delivery nudge
  var bar = document.createElement('button');
  bar.type = 'button';
  bar.className = 'ffs-cartbar';
  bar.setAttribute('aria-live', 'polite');
  bar.innerHTML = '<span class="ffs-cartbar__info"><strong data-l1></strong><small data-l2></small></span><span class="ffs-cartbar__go">View basket →</span>';
  document.body.appendChild(bar);
  bar.addEventListener('click', function(){
    var t = document.querySelector('xo-modal-trigger[xo-name="cart"]');
    if (!t) { location.href = '/cart'; return; }
    t.click();
    // Fallback: if the basket drawer doesn't open, go to the basket page
    setTimeout(function(){
      var m = document.querySelector('xo-modal[xo-name="cart"]');
      var open = m && ((m.matches && (function(){ try { return m.matches(':popover-open'); } catch (e) { return false; } })()) || getComputedStyle(m).display !== 'none');
      if (!open) location.href = '/cart';
    }, 900);
  });
  var lastCount = null;
  function paint(cart){
    if (!cart) return;
    var n = cart.item_count, total = cart.total_price;
    b.classList.toggle('ffs-has-cart', n > 0);
    bar.classList.toggle('is-on', n > 0);
    if (n > 0) {
      bar.querySelector('[data-l1]').textContent = n + (n === 1 ? ' item' : ' items') + ' · ' + money(total);
      var left = FREE - total;
      bar.querySelector('[data-l2]').textContent = left > 0 ? money(left) + ' more for free delivery' : 'Free delivery unlocked';
    }
    if (lastCount !== null && n > lastCount) { bar.classList.remove('is-bump'); void bar.offsetWidth; bar.classList.add('is-bump'); }
    lastCount = n;
  }
  function refresh(){ return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(paint).catch(function(){}); }
  // Update the bar whenever the basket changes (adds here, or changes in the basket drawer)
  if (window.fetch) {
    var f = window.fetch;
    window.fetch = function(input){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = f.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function(){ setTimeout(refresh, 150); }).catch(function(){});
      return p;
    };
  }
  refresh();

  var sticky = document.querySelector('xo-sticky.xo-header__body');
  var last = window.scrollY, quietUntil = 0;
  function update(){
    if (!sticky) return;
    var y = window.scrollY, h = Math.round(sticky.offsetHeight || 72);
    document.documentElement.style.setProperty('--ffs-hdr-h', h + 'px');
    if (y <= h) { b.classList.remove('ffs-hdr-fixed', 'ffs-hdr-show'); last = y; return; }
    b.classList.add('ffs-hdr-fixed');
    if (Date.now() < quietUntil) { b.classList.remove('ffs-hdr-show'); last = y; return; }
    if (y < last - 6) b.classList.add('ffs-hdr-show');
    else if (y > last + 6) b.classList.remove('ffs-hdr-show');
    last = y;
  }
  var ticking = false;
  window.addEventListener('scroll', function(){ if (!ticking) { ticking = true; requestAnimationFrame(function(){ ticking = false; update(); }); } }, { passive: true });
  // Jumping to a section with the drink tabs should not pull the menu down over it
  document.addEventListener('click', function(e){ if (e.target.closest && e.target.closest('a[href^="#ffs-"]')) { quietUntil = Date.now() + 1200; b.classList.remove('ffs-hdr-show'); } }, true);
  update();


  // Shopify's preview strip sits over the bottom of the screen (preview only): keep our bars above it
  function pv(){
    var f = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe'), h = 0;
    if (f) { var r = f.getBoundingClientRect(), s = getComputedStyle(f); if (s.display !== 'none' && s.visibility !== 'hidden' && r.height > 0 && r.top < window.innerHeight) h = Math.max(0, window.innerHeight - r.top); }
    document.documentElement.style.setProperty('--ffs-pv', Math.round(h) + 'px');
  }
  pv(); window.addEventListener('load', pv); window.addEventListener('resize', pv);
  var th = window.Shopify && window.Shopify.theme;
  if (th && th.role !== 'main') setInterval(pv, 1500);

  // Phones: drinks with several pack sizes open a small sheet to pick the size, then add
  var phone = window.matchMedia('(max-width:749px)');
  var sheet = document.createElement('div');
  sheet.className = 'ffs-sheet';
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  sheet.setAttribute('aria-label', 'Choose a pack size');
  sheet.innerHTML = '<div class="ffs-sheet__panel"><div class="ffs-sheet__head"><img alt=""><div class="ffs-sheet__ttl"><h3></h3><p>Choose a pack size</p></div><button type="button" class="ffs-sheet__x" aria-label="Close">×</button></div><fieldset class="ffs-sheet__opts"><legend class="ffs-sr">Pack size</legend></fieldset><button type="button" class="ffs-sheet__go">Add to basket</button></div>';
  document.body.appendChild(sheet);
  var sForm = null, lastFocus = null;
  var sOpts = sheet.querySelector('.ffs-sheet__opts'), sGo = sheet.querySelector('.ffs-sheet__go');
  function esc(t){ return String(t).replace(/[&<>"]/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }
  function sPrice(){
    var c = sOpts.querySelector('input:checked');
    sGo.textContent = c ? 'Add ' + c.dataset.label + ' · ' + c.dataset.price : 'Add to basket';
    sGo.disabled = !c;
    var si = sheet.querySelector('.ffs-sheet__head img'); if (c && c.dataset.image && si) si.src = c.dataset.image.replace('width=720', 'width=200');
  }
  function openSheet(form){
    var card = form.closest('[data-card]');
    sForm = form; lastFocus = document.activeElement;
    sheet.querySelector('h3').textContent = card.querySelector('.ffs-card__title').textContent.trim();
    var img = card.querySelector('img'); var si = sheet.querySelector('.ffs-sheet__head img');
    if (img) { si.src = img.currentSrc || img.src; si.hidden = false; } else si.hidden = true;
    [].forEach.call(sOpts.querySelectorAll('label'), function(l){ l.remove(); });
    [].forEach.call(form.querySelectorAll('.ffs-seg__opt input'), function(o){
      var main = o.parentElement.querySelector('b'), sub = o.parentElement.querySelector('small');
      var l = document.createElement('label'); l.className = 'ffs-sheet__opt';
      l.innerHTML = '<input type="radio" name="ffs-sheet-size" value="' + esc(o.value) + '"' + (o.checked ? ' checked' : '') + (o.disabled ? ' disabled' : '') + '>' + (o.dataset.image ? '<img class="ffs-sheet__pic" src="' + esc(o.dataset.image.replace('width=720', 'width=160')) + '" alt="">' : '') + '<span class="ffs-sheet__txt"><b>' + esc(main ? main.textContent : '') + (sub ? ' · ' + esc(sub.textContent) : '') + '</b><small>' + (o.disabled ? 'Sold out' : esc(o.dataset.unit)) + '</small></span><strong>' + esc(o.dataset.price) + '</strong><i class="ffs-sheet__tick" aria-hidden="true"></i>';
      l.querySelector('input').dataset.price = o.dataset.price;
      l.querySelector('input').dataset.image = o.dataset.image || '';
      l.querySelector('input').dataset.label = main ? main.textContent : '';
      sOpts.appendChild(l);
    });
    if (!sOpts.querySelector('input:checked')) { var f = sOpts.querySelector('input:not(:disabled)'); if (f) f.checked = true; }
    sPrice();
    sheet.classList.add('is-open');
    setTimeout(function(){ var c = sOpts.querySelector('input:checked'); if (c) c.focus(); }, 50);
  }
  function closeSheet(){ sheet.classList.remove('is-open'); sForm = null; if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  sOpts.addEventListener('change', sPrice);
  sheet.addEventListener('click', function(e){ if (e.target === sheet || e.target.closest('.ffs-sheet__x')) closeSheet(); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });
  sGo.addEventListener('click', function(){
    var c = sOpts.querySelector('input:checked'); if (!c || !sForm) return;
    var form = sForm;
    var target = form.querySelector('.ffs-seg__opt input[value="' + c.value + '"]');
    if (target) { target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true })); }
    closeSheet();
    form.dataset.ffsSized = '1';
    if (form.requestSubmit) form.requestSubmit(); else form.querySelector('[data-add]').click();
  });
  document.addEventListener('submit', function(e){
    var form = e.target.closest && e.target.closest('[data-add-form]');
    if (!form || !phone.matches || !form.querySelector('.ffs-seg__opt input')) return;
    if (form.dataset.ffsSized) { delete form.dataset.ffsSized; return; }
    e.preventDefault(); e.stopImmediatePropagation();
    openSheet(form);
  }, true);

  // Phones: the drinks bar at the bottom only appears once you reach the bundles
  var first = document.getElementById('ffs-g-bundles');
  function tabs(){ if (!first) return; b.classList.toggle('ffs-bar-on', first.getBoundingClientRect().top < window.innerHeight * 0.75); }
  window.addEventListener('scroll', tabs, { passive: true });
  window.addEventListener('resize', tabs);
  window.addEventListener('load', tabs);
  tabs();
})();
